export const isPinned = [
    { label: "Not Pinned", value: false },
    { label: "Pinned", value: true }
] as const;
